import { render } from "./ReleaseCoupons.vue?vue&type=template&id=5c1bb8b6&scoped=true"
import script from "./ReleaseCoupons.vue?vue&type=script&lang=js"
export * from "./ReleaseCoupons.vue?vue&type=script&lang=js"

import "./ReleaseCoupons.vue?vue&type=style&index=0&id=5c1bb8b6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1bb8b6"]])

export default __exports__